/**********************************************************
Chemical View
**********************************************************/
import ChemicalApplicationTable from './chem_app_table';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchChemicalApplications, selectApplicationToView } from '../../actions/chem_app_actions';
import { fetchEmployees } from '../../actions/utils_actions';

class ChemicalApplicationView extends Component {
  componentDidMount() {
    this.props.fetchChemicalApplications();
    if (this.props.employees.length === 0) this.props.fetchEmployees();
  }
  render() {
    return (
      <div className="row">
        <div className="chem-app-table-view">
          <ChemicalApplicationTable chemicalApplications={this.props.chemicalApplications} chemicalList={this.props.chemicalList}
            employees={this.props.employees} selectApplicationToView={this.props.selectApplicationToView} selectedApp={this.props.selectedApp}
          />
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    chemicalList: state.cultivation.chemical.chemicalList,
    chemicalApplications: state.cultivation.chemApp.chemicalApplications.displaying,
    employees: state.cultivation.utils.employees,
    selectedApp: state.cultivation.chemApp.view
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchChemicalApplications,
    fetchEmployees,
    selectApplicationToView
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(ChemicalApplicationView);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/chem_app/chem_app_view.js